import React from 'react'
import { supabase } from '@/lib/supabase'

export function useRevshareAllowed() {
  const [allowed, setAllowed] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    let mounted = true

    ;(async () => {
      try {
        const { data, error } = await supabase.rpc('user_revshare_allowed')
        if (!mounted) return
        if (error) {
          console.error('user_revshare_allowed error', error)
          setAllowed(false)
          return
        }
        setAllowed(Boolean(data))
      } catch (e) {
        console.error('user_revshare_allowed error', e)
        if (mounted) setAllowed(false)
      }
    })()

    return () => {
      mounted = false
    }
  }, [])

  return allowed
}

